import { CodedError } from './CodedError';
import { errorCodes } from './constants/errorCodes';

export default class OAuthNotSetupError extends CodedError {
  static get errorName() {
    return errorCodes.oauthNotSetupError.code;
  }

  constructor(message: string = errorCodes.oauthNotSetupError.message) {
    super(message);
    this.code = errorCodes.oauthNotSetupError.code;
    this.message = `${message} ${errorCodes.oauthNotSetupError.code}`;
    this.name = errorCodes.oauthNotSetupError.name;
  }
}
